import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar } from "@fortawesome/free-regular-svg-icons";
import { Pie } from "react-chartjs-2";
import { Chart } from "chart.js";
import { CategoryScale, ArcElement, Tooltip, Legend } from "chart.js";
import { useEffect, useState } from "react";
import { ChartDataProps } from "../../../../utils/types";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { GET_DEPARTMENT_ANALYTICS_END_POINT } from "../../../../config/config";
import PieLoading from "./PieChartLoading";

Chart.register(CategoryScale, ArcElement, Tooltip, Legend);

export default function DepartmentDetails (){

    const [chartData, setChartData] = useState<ChartDataProps>({
            labels: [],
            datasets: [
                {
                    label: '',
                    data: [],
                    backgroundColor: [],
                    borderWidth: 2,
                }
            ]
    });
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(()=>{
        const getChartData = async() => {
            try{
                const data = await api.get(GET_DEPARTMENT_ANALYTICS_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setChartData(data.data);
                setLoading(false);
            }catch(e){}
        }
        setTimeout(getChartData, 500)
    })

    return (
        <div className="bg-white p-2 w-full rounded shadow-xl">
            <div>
                <FontAwesomeIcon icon={faChartBar} />&nbsp;
                Department analytics
            </div>
            <div className="text-gray-600 w-full my-4 flex justify-center">
                <div className="w-[58rem]" style={{ height: '300px'}}>
                    {loading ? (
                        <PieLoading />
                    ) : (
                        <>
                            <Pie
                            data={chartData}
                            options={{
                                plugins : {
                                    title : {
                                        display : true,
                                        text : 'Sample Chart design'
                                    },
                                    legend : {
                                        display : true,
                                        position : 'right',
                                        labels : {
                                            padding : 10
                                        }
                                    },
                                    tooltip : {
                                        enabled : true,
                                        callbacks: {
                                            label: function (tooltipItem) {
                                                let label = tooltipItem.label || '';
                                                if (label) {
                                                    label += ': ';
                                                }
                                                label += tooltipItem.raw;
                                                return label;
                                            }
                                        }
                                    }
                                },
                                responsive : true,
                                maintainAspectRatio: false,
                                animation : {
                                    duration: 500,
                                    easing : 'linear'
                                }
                            }}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}